import React from "react";
import tw from "twin.macro";

import { PrimaryButton, Link2 } from "../Components/MiscStyles/Buttons";

const Container = tw.div`relative md:mb-0 mb-80`;

const Header = tw.div`h-90 bg-secondary relative`;
const HeaderContent = tw.div`text-white absolute bottom-0 md:mx-72 mx-10  pb-10 text-4xl`;

const Content = tw.div` md:mx-72 mx-10  my-20 `;
const FlexContainer = tw.div`md:flex  items-center`;
const LeftContainer = tw.div`md:w-1/2 md:pr-10 `;
const RightContainer = tw.div`md:w-1/2  md:pl-10 `;

const Section2 = tw.div` bg-gray-200`;
const WideContainer = tw.div`md:w-8/12 md:pl-72 md:pr-24 mx-10`;
const SmallContainer = tw.div`md:w-4/12`;

const Section3 = tw.div`mb-20 md:mb-0`;
const SecondWideContainer = tw.div`md:w-8/12 md:pr-72 md:pl-24 mx-10`;
const SecondSmallContainer = tw.div`md:w-4/12`;

const Heading = tw.h2`text-3xl  font-playfair`;
const Subheading = tw.h5`text-sm my-4 `;
const Paragraph = tw.h5`text-sm my-4 opacity-70 `;
const HeaderParagraph = tw.h5`text-smm my-2 w-3/4`;

export default () => {
  return (
    <Container>
      <Header>
        <HeaderContent>
          <Heading>ABOUT</Heading>
          <HeaderParagraph>
            SEE BELOW TO HAVE A GREATER UNDERSTANDING OF WHERE SINGH DRYWALL
            STARTED, WHERE WE ARE GOING AND WHAT WE HOLD IMPORTANT TO US AS A
            COMPANY
          </HeaderParagraph>
        </HeaderContent>
      </Header>
      <Content>
        <Heading>Our Story</Heading>
        <Subheading>
          As a full service General Contractor, Construction Management and
          Construction Consulting Firm, we pride ourselves on our commitment to
          excellence and professionalism.
        </Subheading>
        <FlexContainer>
          <LeftContainer>
            <Paragraph>
              In 2007 Christopher J. Spano recognized a genuine need in the New
              York and New Jersey real estate markets for a midsize high-end
              construction firm with a focus on premium customer service and
              satisfaction. From that need, CJS Builders was born.
              <br />
              <br /> While 2008 was certainly an inauspicious time to launch a
              new construction business, CJS’s incredibly strong work ethic and
              disciplined perseverance allowed it not only to greatly perform,
              but to emerge stronger and better suited for the future.
              <br />
              <br /> CJS quickly built a stellar reputation within the high end
              retail markets. The challenges of the aggressive{" "}
            </Paragraph>
          </LeftContainer>

          <RightContainer>
            <Paragraph>
              retail fit-out market conditioned our team to excel at managing
              accelerated schedules, streamline procurement and logistics, and
              consistently deliver the premium quality required in high end
              spaces. Our drive to efficiently deliver the best quality is at
              the heart of CJS.
              <br />
              <br />
              This has allowed us to stand the tests of time and crisis and
              provide our clients and their full project teams with a broad
              range of services, including pre-construction services, general
              contracting,construction management, construction consulting and
              real estate development services. CJS has enjoyed its own
              evolution through the years and is excited to continue to develop
              and progress as a company.
            </Paragraph>
          </RightContainer>
        </FlexContainer>
      </Content>
      <Section2>
        <FlexContainer>
          <WideContainer>
            <Heading>Our Vision</Heading>
            <Subheading>
              CJS recognizes that to prosper in the construction industry, we
              cannot be complacent or accepting of the status quo.We need always
              to strive to improve our services and delivery in all facets of
              our business.
            </Subheading>
            <Paragraph>
              In early 2018, CJS Builders made a conscious decision to begin its
              next evolution as a company by focusing on the development of our
              company brand, company culture, and the integration of the latest
              technology both internally and through our project delivery
              services.
              <br />
              <br /> With this approach this will enable CJS to remain as a
              premium service contractor, providing both clients and projects
              with the most up to date construction methods, management
              processes and uses of technology. Making all your experiences with
              CJS both effective and efficient.
              <br />
              <br />
              This is premium service mindset is apparent in all at CJS, from
              our front receptionist all the way up to ownership
            </Paragraph>
          </WideContainer>
          <SmallContainer>
            <img src="https://www.drywallpro-cut.co.uk/wp-content/uploads/2021/01/Drywall4.png" />
          </SmallContainer>
        </FlexContainer>
      </Section2>

      <Section3>
        <FlexContainer>
          <SecondSmallContainer>
            <img src="https://www.nakshaconstruction.com/wp-content/uploads/2022/01/aa924ab2170b35f70186be348bbb27c9.jpg" />
          </SecondSmallContainer>

          <SecondWideContainer>
            <Subheading>Our goals include, but are not limited to:</Subheading>

            <Paragraph>
              - Consistent emphasis on our internal company culture and
              collaborative spirit.
            </Paragraph>
            <Paragraph>
              - Greater use of technology to improve efficiency and reduce our
              impact on the environment.
            </Paragraph>
            <Paragraph>
              - Operating and running as a "Green Company" through building a
              heightened understanding of ways to reduce our environmental
              impact. (The CJS teams are LEED certified).
            </Paragraph>
            <Paragraph>
              - Develop and drive the CJS Brand by providing transparency into
              our business and ways of working.
            </Paragraph>
            <PrimaryButton href="/Services">VIEW OUR SERVICES</PrimaryButton>
            <br />    <br />    <br />    <br />
          </SecondWideContainer>
        </FlexContainer>
      </Section3>
    </Container>
  );
};
